export const queryKeys = {
  market: (competitionCode: string, seasonCode: string, poolCode: string) =>
    ["market-standings", competitionCode, seasonCode, poolCode] as const,

  portfolio: (poolCode: string) => ["portfolio", poolCode] as const,

  leaderboard: (poolCode: string) => ["leaderboard", poolCode] as const,

  homeSummary: () => ["home-pool-summary"] as const,

  orderbookLatest: (competitionCode: string, seasonCode: string, poolCode: string) =>
    ["orderbook-latest", competitionCode, seasonCode, poolCode] as const,

  dirtyView: (scope: "portfolio" | "leaderboard" | "home", poolCode: string) =>
    ["dirty-view", scope, poolCode] as const,
};
